<h2 mat-dialog-title class = "title">Copy Data Profile</h2>

<form name="newProfileForm" [formGroup]="form" (ngSubmit)="duplicateProfile()" class="example-form">

  <div class="form-row">
    <label class="space label">Profile to copy</label>

    <mat-form-field class="form-field">
      <mat-label>Select Profile</mat-label>
      <mat-select formControlName="profilelist" (selectionChange)="onProfileChange($event)">
        <!-- <mat-option [value]="null">None</mat-option> -->
        @for (profile of profilelist; track profile) {
          <mat-option [value]="profile.id">{{ profile.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>


  <div class="form-row">
    <label class="space label">New profile name</label>

    <mat-form-field class="form-field">
      <input matInput name="name" formControlName="name" required>
    </mat-form-field>
  </div>


  <div class="form-row">
    <label class="space label">New profile description</label>

    <mat-form-field class="form-field">
      <textarea matInput name="description" formControlName="description" rows="4" required></textarea>
    </mat-form-field>
  </div>


  <div class="buttonspace">
    <button 
      type="submit"
      mat-raised-button 
      color="primary"
      [disabled]="!isProfileSelected || !form.valid || form.pristine">
      Copy Profile
    </button>
  </div>

</form>